.divider {
    border-right: 2px solid #EAEAEA !important;
    height: 100% !important;
  }
  
  .marginBottom {
    margin-bottom: .75rem !important;
  }
  